/**
 * Axios 超时（毫秒）。默认实例 15s 对大文件 multipart 过短，上传单独拉长。
 * @see frontend/src/api/http.js
 */

/** multipart / 大文件上传（FormData），含 OSS、大图压缩等耗时 */
export const MULTIPART_UPLOAD_TIMEOUT_MS = 300000

/** 报关单反馈 POST（JSON，附图 meta 或链路较慢） */
export const DECLARATION_FEEDBACK_POST_TIMEOUT_MS = 120000

/** 首页看板 GET /dashboard（冷启动重算或远端 MySQL 较慢） */
export const DASHBOARD_GET_TIMEOUT_MS = 120000

/** 发客户微秘书等业务：业务库 wechat_groups（及本库客户管理） */
export const CUSTOMER_PORTAL_WEIMI_POST_TIMEOUT_MS = 90000

/**
 * 报关单 POST/PUT（含合并运单）：业务库双 SQL 可能比默认 30s 长，拉长等待。
 * @see backend/lib/BusinessMergeWaybillOrderInfo.php
 * @see backend/lib/DeclarationMergeWaybillSync::prepareFromRemote
 */
export const DECLARATION_MERGE_SAVE_TIMEOUT_MS = 180000
